import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styled, { css } from "styled-components";
import { useLazyQuery } from "@apollo/client";

import RefreshingImage from "frontend/components/core/RefreshingImage";

import { FETCH_PHOTO_UPLOAD_URLS } from "../../queries";

import { updateUpload } from "../../slices/uploadsSlice";

import colors from "core/colors";

export const RefreshingImageStyled = styled(RefreshingImage)`
    /* center absolutely positioned asset */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;

    /* resize asset so longest side spans parent container */
    max-height: 100%;
    max-width: 100%;

    background-color: ${colors.primary.whisker};

    ${({ imageProps: { imageIsBlurred } }) =>
        imageIsBlurred &&
        css`
            filter: blur(15px);
        `};
`;

const PhotoModRefreshingImage = ({ src, id, alt, imageProps }) => {
    const dispatch = useDispatch();

    const [refreshImageUrl] = useLazyQuery(FETCH_PHOTO_UPLOAD_URLS, {
        fetchPolicy: "network-only",
        variables: {
            photoUploadIds: [id]
        },
        onCompleted: ({ fetchPhotoUploadUrls }) => {
            const newUploadData = fetchPhotoUploadUrls.items[0];
            dispatch(updateUpload(newUploadData));
        }
    });

    return (
        <RefreshingImageStyled
            src={src}
            alt={alt}
            fetchNewUrl={refreshImageUrl}
            imageProps={imageProps}
        />
    );
};

PhotoModRefreshingImage.propTypes = {
    src: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    imageProps: PropTypes.object
};

export default PhotoModRefreshingImage;
